import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "@/core/lib/navigation";
import { ToolBuilder } from "@/ui/components/ai-documents/tool-builder";

export const Route = createFileRoute("/_workspace/generate/templates/new")({
  component: NewTemplatePage,
});

function NewTemplatePage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-3xl space-y-6">
        <div className="space-y-3">
          <Link
            href="/generate"
            className="inline-flex items-center gap-1.5 text-muted-foreground text-sm underline-offset-4 hover:underline"
          >
            <ArrowLeftIcon className="size-4" />
            Back to Generate
          </Link>
          <div className="space-y-1">
            <h1 className="font-bold text-2xl tracking-tight">New template</h1>
            <p className="text-muted-foreground text-sm">
              Build a reusable document template with your own placeholders.
            </p>
          </div>
        </div>

        <ToolBuilder tool={null} entityNoun="template" />
      </div>
    </main>
  );
}
